(function($, window, document, Attendee, AttendeeCaptureDoneModal, AttendeeCaptureEditModal) {
    var ATTENDEE_KEY = 'attendee-model';
    var AC_NOTIFICATION = 'Attention: You must add attendee names to each ticket prior to the festival date.';

    // Run when the DOM is ready
    $(init);
    
    // Add all DOM manipulation here
    function init() {
        var $acLinks = $('[data-ac-item-id]');

        var getModelFromJSON = function(itemId, data) {
            var model = new Attendee(itemId);
            model.setData(data);
            return model;
        };

        var updateAnchorText = function($a, descriptor) {
            var desc = descriptor ? descriptor : 'Details';         

            // Remove all other classes and add the right class if it doesn't exist
            if (!$a.hasClass('attendee-dark')) {
                $a.removeClass();
                $a.addClass('attendee-dark');
            }

            var regData = $a.data(ATTENDEE_KEY);

            if (regData) {
                var innerText = [regData.getField('firstName'), regData.getField('lastName'), '|', desc].join(' ');
                $a.text(innerText);
            }
        };

        var displayAddAttendeeText = function ($anchor) {
            var add = '<span style="margin-right:.5em;" class="glyphicon glyphicon-plus-sign"></span>Add Attendee';
            $anchor.html(add);
        };

        var update = function(result) {
            // Get the anchor tag and replace its innertext
            var itemId = result.getItemId();
            var $a = $('[data-ac-item-id="' + itemId + '"]');

            $a.data(ATTENDEE_KEY, result);

            updateAnchorText($a, 'Edit');
        };

        // Display the Attendee Capture notification if there is at least one Add Attendee link visible
        function attendeeNotification() {
            var isIncomplete = $("a:contains('Add Attendee')").length ? true : false;
            if (isIncomplete) {
                var $acNotification = $('<div></div>').addClass('attendee-notification').text(AC_NOTIFICATION);
                $('div.order-number').after($acNotification);
            }
        }

        // Initialize the Attendee Modals
        AttendeeCaptureDoneModal.init();
        // Initialize the edit modal with a callback function
        AttendeeCaptureEditModal.init(update);

        // Runs right away to create and attach Attendee models to the anchor tags
        // and updates their innertext
        $acLinks.each(function() {
            var $link = $(this);
            var seatReg = $link.attr('data-ac-seat-reg');
            seatReg = JSON.parse(seatReg);

            if (seatReg) {
                var model = getModelFromJSON($link.attr('data-ac-item-id'), seatReg);

                // Store the model with a reference to the anchor
                $link.data(ATTENDEE_KEY, model);

                // Update the anchor's innertext
                updateAnchorText($link, 'Edit');
            } else {
                // Style link like it has no attendee capture information
                $link.removeClass().addClass('attendee-red');
                displayAddAttendeeText($link);
            }
        });

        // allowing for editing of ticket post printing ticket:SAND-1465
        // $acLinks.each(function() {
        //     var $link = $(this);

            // var isPrinted = $link.attr('data-ac-printed');
            // if (isPrinted) {
            //     updateAnchorText($link, 'Details');
            // }
        // });

        // Attach click handlers to the Attendee Capture anchor tags
        $acLinks.on('click', function(ev) {
            // allowing for editing of ticket post printing ticket:SAND-1465
            // var $link = $(this);

            // Check if printed=
            // var isPrinted = $link.attr('data-ac-printed');
            // if (isPrinted) {
            //     AttendeeCaptureDoneModal.setData($link.data(ATTENDEE_KEY));
            //     AttendeeCaptureDoneModal.showModal();
            //     return;
            // }

            // Set the Edit Modal model data
            if ($(this).data(ATTENDEE_KEY)) {
                AttendeeCaptureEditModal.setData( $(this).data(ATTENDEE_KEY) );
            } else {
                var attendee = new Attendee($(this).attr('data-ac-item-id'));
                AttendeeCaptureEditModal.setData(attendee);
            }

            AttendeeCaptureEditModal.showModal();
        });

        // Decides whether to display the Attendee Capture notification
        attendeeNotification();
    }

}(window.jQuery, window, document, Attendee, AttendeeCaptureDoneModal, AttendeeCaptureEditModal));
